import { useEffect, useRef, useState } from 'react'
import Offering from '../../Common/Offering/Offering'
import Section from '../../Common/Section/Section'
import './OfferingsSection.css'
import { offeringData } from '../../../data/OfferingsData'
import OfferingInfo from '../../../models/OfferingInfo'
import OfferingDropdown from '../../Common/OfferingDropdown/OfferingDropdown'

function OfferingsSection() {

  // sets offering data
  const [offerings] = useState<OfferingInfo[]>(offeringData)


  const [expandedId, setExpandedId] = useState<string | null>(null)
  const [offeringExpanded, setOfferingExpanded] = useState<boolean>(false)
  const [expandedOffering, setExpandedOffering] = useState<OfferingInfo | null>(null)

  const expandedDropdownRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    setOfferingExpanded(expandedId !== null)
    setExpandedOffering(offerings.find((o) => (o.id === expandedId)) ?? null)
  }, [expandedId, offerings])

  useEffect(() => {
    if (offeringExpanded && expandedDropdownRef.current) {
      const offset = 180;
      const elementTop = expandedDropdownRef.current.getBoundingClientRect().top + window.scrollY;
      const scrollTo = elementTop - offset;

      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth',
      });
    }
  }, [offeringExpanded])


  // handles setting the currently expanded offering
  const handleLearnMore = (id: string) => {
    setExpandedId(prev => (prev === id ? null : id));
  };

  return (
    <Section 
      id={"offerings-section"} 
      sectionTitle='Services I offer'
      >
      <div className='offerings-container centered'>
        {offerings.map((offering) => (
          <Offering
            key={offering.id}
            offeringData={offering}
            onLearnMore={handleLearnMore}
            isExpanded={expandedId === offering.id}
          />
        ))}
      </div>
      {
        offeringExpanded && <OfferingDropdown offeringInfo={expandedOffering} ref={expandedDropdownRef}/>
      }
    </Section>
  )
}

export default OfferingsSection